// extracted by mini-css-extract-plugin
export default {"calcontainer":"MyCalendar_calcontainer__uSi5J","currentDayText":"MyCalendar_currentDayText__HGHtU"};